import { render, staticRenderFns } from "./DashboardDetailModal.vue?vue&type=template&id=a2f7aa44&scoped=true"
import script from "./DashboardDetailModal.vue?vue&type=script&lang=js"
export * from "./DashboardDetailModal.vue?vue&type=script&lang=js"
import style0 from "./DashboardDetailModal.vue?vue&type=style&index=0&id=a2f7aa44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2f7aa44",
  null
  
)

export default component.exports